import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
  dispositions: {},
  currentGmtTime: 0,
  jsOperation: null,
  timeDiff: 0,
  status: false,
};

const getDispositionStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const getDispositionSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    dispositions: action.dispositions,
    currentGmtTime: action.currentGmtTime,
    jsOperation: action.operation,
    timeDiff: action.timeDiff, 
  })
};

const getDispositionFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const setDispositionStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const setDispositionSuccess = (state, action) => {
  return updateObject(state, {error: null, loading: false, status: action.status});
};

const setDispositionFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, status: false,});
};

const setDispositionFailReset = (state,action)=>{
  return updateObject(state, {loading: false,status: false,
  });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DISPOSITION_START:
      return getDispositionStart(state, action);
    case actionTypes.GET_DISPOSITION_SUCCESS:
      return getDispositionSuccess(state, action);
    case actionTypes.GET_DISPOSITION_FAIL:
      return getDispositionFail(state, action);

    case actionTypes.SET_DISPOSITION_START:
      return setDispositionStart(state, action);
    case actionTypes.SET_DISPOSITION_SUCCESS:
      return setDispositionSuccess(state, action);
    case actionTypes.SET_DISPOSITION_FAIL:
      return setDispositionFail(state, action);
    case actionTypes.SET_DISPOSITION_RESET:
      return setDispositionFailReset(state, action);
    default:
      return state;
  }
};

export default reducer;
